"use client";
import _extends from '@babel/runtime/helpers/extends';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { breadcrumb, list, item, link, text } from './styles.js';
import { ThemeProvider } from 'styled-components';
import { IconChevronRight } from '../icons/ui_navigation/IconChevronRight.web.js';
import { IconButton } from '../IconButton/IconButton.web.js';
import { Hidden } from '../Hidden/Hidden.web.js';
import { IconChevronLeft } from '../icons/ui_navigation/IconChevronLeft.web.js';
import { IconHomeFilled } from '../icons/ui_general/IconHomeFilled.web.js';
import { useTheme } from '../utils/theming/useTheme.js';
import { spacing } from '../constants/spacing.js';
import { renderComponentOrElement } from '../utils/helpers/component.js';

var _excluded = ["tag", "icon", "items", "homeUrl", "homeAriaLabel", "mobileItem", "color", "disableVisited", "size", "lineHeight", "aria-label"];
// istanbul ignore next: TODO: tag default is never used, but needed for typings

var Breadcrumb = function Breadcrumb(_ref) {
  var _ref2;
  var _ref$tag = _ref.tag,
    tag = _ref$tag === undefined ? 'a' : _ref$tag,
    _ref$icon = _ref.icon,
    icon = _ref$icon === undefined ? IconHomeFilled : _ref$icon,
    _ref$items = _ref.items,
    items = _ref$items === undefined ? [] : _ref$items,
    _ref$homeUrl = _ref.homeUrl,
    homeUrl = _ref$homeUrl === undefined ? '/' : _ref$homeUrl,
    _ref$homeAriaLabel = _ref.homeAriaLabel,
    homeAriaLabel = _ref$homeAriaLabel === undefined ? 'Return home' : _ref$homeAriaLabel,
    mobileItem = _ref.mobileItem,
    colorProp = _ref.color,
    _ref$disableVisited = _ref.disableVisited,
    disableVisited = _ref$disableVisited === undefined ? false : _ref$disableVisited,
    _ref$size = _ref.size,
    size = _ref$size === undefined ? 's' : _ref$size,
    lineHeight = _ref.lineHeight,
    ariaLabel = _ref['aria-label'],
    props = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  var color = colorProp || theme.tokens.text.link;
  var lastItem = (_ref2 = mobileItem !== null && mobileItem !== undefined ? mobileItem : _toConsumableArray(items).reverse().find(function (item) {
    return item.params;
  })) !== null && _ref2 !== undefined ? _ref2 : items[items.length - 1];
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(breadcrumb, _extends({
    "data-testid": "elemental-Breadcrumb",
    "aria-label": ariaLabel || 'Breadcrumb',
    mv: {
      "default": spacing.xxxs,
      s: spacing.xs
    },
    $weight: props.weight,
    $italic: props.italic,
    $lineHeight: lineHeight
  }, props), /*#__PURE__*/React.createElement(Hidden, {
    above: "xs"
  }, /*#__PURE__*/React.createElement(list, null, lastItem && /*#__PURE__*/React.createElement(item, {
    "aria-current": "false",
    "data-testid": "elemental-Breadcrumb-".concat(lastItem.title, "-mobile")
  }, /*#__PURE__*/React.createElement(IconChevronLeft, {
    mr: {
      "default": 0,
      s: spacing.xxxxs
    },
    color: theme.colors.text
  }), lastItem.params ? /*#__PURE__*/React.createElement(link, _extends({
    tag: tag,
    weight: "medium",
    noUnderline: true,
    color: color,
    size: size,
    disableVisited: disableVisited
  }, lastItem.params), lastItem.title) : /*#__PURE__*/React.createElement(text, {
    weight: "light",
    size: size
  }, lastItem.title)))), /*#__PURE__*/React.createElement(Hidden, {
    below: "xs"
  }, /*#__PURE__*/React.createElement(list, null, /*#__PURE__*/React.createElement(item, null, /*#__PURE__*/React.createElement(IconButton, {
    color: color,
    tag: "a",
    href: homeUrl,
    status: "plain",
    icon: renderComponentOrElement(icon, {
      color: color
    }, true),
    "aria-label": homeAriaLabel
  })), items.map(function (item$1, index) {
    var isLast = index === items.length - 1;
    return /*#__PURE__*/React.createElement(item, {
      "aria-current": isLast ? 'page' : 'false',
      key: index,
      "data-testid": "elemental-Breadcrumb-".concat(item$1.title)
    }, /*#__PURE__*/React.createElement(IconChevronRight, {
      mr: {
        "default": 0,
        s: spacing.xxxxs
      },
      color: theme.colors.text
    }), item$1.params ? /*#__PURE__*/React.createElement(link, _extends({
      weight: isLast ? 'light' : 'medium',
      tag: tag,
      noUnderline: true,
      color: color,
      size: size,
      disableVisited: disableVisited
    }, item$1.params), item$1.title) : /*#__PURE__*/React.createElement(text, {
      weight: isLast ? 'light' : 'medium',
      size: size
    }, item$1.title));
  })))));
};

export { Breadcrumb };
